import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RouteEnum } from "../../../common/enums/RouteEnum";

interface Options {
    isNotFound: boolean;
}

export const useRedirectOnProductDetailNotFound = ({
    isNotFound,
}: Options): boolean => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!isNotFound) {
            return;
        }

        navigate(RouteEnum.PRODUCT_RANGE, { replace: true });
    }, [isNotFound, navigate]);

    return isNotFound;
};
